// /src/components/Chip.jsx
import React from 'react';

export const Chip = ({ children }) => (
  <span 
    className="px-3 py-1 rounded-full text-xs font-semibold" 
    style={{ background: 'var(--tag-bg)', color: 'var(--tag-text)' }}
  >
    {children}
  </span>
);